export const isAdminPage = () => {
  return window.location.pathname.includes('admin')
}
